<template>
  <div>
    <v-dialog v-model="value" max-width="80%" persistent scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md4> &nbsp; </v-flex>
            <v-flex xs12 sm4 md4 lg4 xl4>
              <v-flex class="titleSearch">
                <v-text-field
                  v-model="search"
                  label="Buscar"
                  prepend-inner-icon="search"
                  solo-inverted
                  clearable
                  @click:clear="
                    () => {
                      search = ''
                      getItems()
                    }
                  "
                  @keyup.enter="getItems"
                />
              </v-flex>
            </v-flex>
            <v-flex md4> &nbsp; </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-data-table
              style="width: 100%"
              :headers="headers"
              :items="items"
              no-data-text="No hay asistencias"
              :rows-per-page-items="[10, 15, 25]"
              rows-per-page-text="Registros por página"
              no-results-text="No hay coincidencias"
              ref="table"
              :total-items="totalItems"
              :loading="loading"
              :pagination.sync="pagination"
              @update:pagination="getItems"
            >
              <template v-slot:headers="props">
                <th
                  v-for="header in props.headers"
                  style="width: 250px; max-width: 250px; min-width: 250px"
                >
                  {{ header.text }}
                </th>
              </template>
              <template v-slot:items="props">
                <td
                  class="text-xs-center"
                  style="width: 250px; max-width: 250px; min-width: 250px"
                >
                  {{ props.item.parent.firstName }}
                </td>
                <td
                  class="text-xs-center"
                  style="width: 250px; max-width: 250px; min-width: 250px"
                >
                  {{ props.item.parent.lastName }}
                </td>
                <td
                  class="text-xs-center"
                  style="width: 250px; max-width: 250px; min-width: 250px"
                >
                  {{ props.item.parent.email }}
                </td>
                <td
                  class="text-xs-center"
                  style="width: 250px; max-width: 250px; min-width: 250px"
                >
                  {{ props.item.inAt | formatDate }}
                </td>
              </template>
            </v-data-table>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn flat color="primary" @click="downloadReportAll"
            >Descargar reporte</v-btn
          > -->
          <v-btn flat color="primary" @click="downloadXlsx">
            Descargar xlsx
          </v-btn>
          <v-btn flat color="primary" @click="close">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import 'vuex'
import { _downloadFileFromContentDisposition } from '../../utils/genericUtils.js'
import Error from '../Dialogs/Error.vue'
import Loading from '../Dialogs/Loading.vue'
import Success from '../Dialogs/Success.vue'
// import { mapGetters } from 'vuex'
// import { noticeMixin } from '../../Mixins/NoticeReportsMixin'
export default {
  props: ['title', 'notice', 'value'],
  components: {
    Loading,
    Error,
    Success,
  },
  // mixins: [noticeMixin],
  watch: {
    value: function (value) {
      if (value === true) {
        this.getItems()
      } else {
        this.reset()
      }
    },
  },
  mounted() {},
  data: () => ({
    toast: {
      loading: false,
      error: false,
      success: false,
    },
    search: '',
    // avatarSize: '30px',
    // tile: false,
    // userImg: null,
    // working: {
    //   wUpdate: false,
    //   wImage: false,
    // },
    headers: [
      {
        text: 'Nombre del tutor',
        align: 'center',
        value: 'firstName',
      },
      {
        text: 'Apellidos del tutor',
        align: 'center',
        value: 'lastname',
      },
      {
        text: 'Correo',
        align: 'center',
        value: 'lastname',
      },
      { text: 'Fecha y hora', align: 'center', value: 'date' },
    ],
    // searchText: '',
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 25,
    },
  }),
  methods: {
    reset() {
      this.search = ''
      this.items = []
      this.totalItems = 0
      this.pagination = {
        page: 1,
        rowsPerPage: 25,
      }
    },
    close() {
      this.userForm = {}
      this.$emit('input', !this.value)
    },
    getItems() {
      this.loading = true

      this.$store
        .dispatch('notice/getNoticeDetailAttendanceParent', [
          this.notice.id,
          {
            offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
            size: this.pagination.rowsPerPage,
            search: this.search === '' ? undefined : this.search,
          },
        ])
        .then(({ data }) => {
          this.items = data.data
          this.totalItems = data.total
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
          this.$forceUpdate()
        })
    },
    downloadXlsx() {
      this.toast.loading = true
      this.$store
        .dispatch('notice/downloadParentAttendanceXlsx', [
          this.notice.id,
          {
            search: this.search === '' ? undefined : this.search,
          },
        ])
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
        })
        .catch((error) => {
          this.toast.error = true
          console.log(error)
        })
        .finally(() => {
          this.toast.loading = false
        })
    },
  },
  // computed: {
  //   ...mapGetters(['getBranch']),
  // },
}
</script>

<style>
.titleSearch .v-input .v-text-field .v-input__slot {
  border-radius: 33px !important;
}
</style>

<!-- <style scoped>
td,
th {
  width: 376px;
  max-width: 376px;
  min-width: 376px;
}
</style> -->
